import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderTypeGroup } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useModify = () => {
  const { locale } = useLocale();
  const { mutate: modifyStakeholders, isPending } = useAppMutation(
    [QueryKey.STAKEHOLDERS_BULK_MODIFY],
    {
      mutationFn: ({
        companyId,
        typeGroup,
        file,
      }: {
        companyId: string;
        file: File;
        typeGroup: StakeholderTypeGroup;
      }) =>
        ApiService.uploadFile().callback(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', typeGroup, 'modify'],
          },
          ['file', file],
          { locale },
        ),
    },
  );
  return { modifyStakeholders, isPending };
};
